/**
 * Beyond Sure — input validation helpers.
 *
 * Intentionally tiny + framework-free so they can be unit-tested
 * later without spinning up React.
 */

/** Pragmatic email regex — RFC 5322 in full is unreadable and over-strict.
 *  This is the same shape Stripe / Slack / GitHub use at the field layer:
 *  one or more "name-y" chars, an @, a domain with at least one dot. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > 254) return false;
  return EMAIL_RE.test(trimmed);
}

/** A tiny helper to keep error-message branching readable at the call site. */
export function emailFieldError(value: string): string | null {
  if (value.trim().length === 0) return null; // empty = no error yet (untouched)
  if (!isValidEmail(value)) return "Enter a valid email address.";
  return null;
}
